import { ConfigProvider, Flex, Modal, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import CreateExpenseForm from "./CreateExpenseForm";
import EditExpenseForm from "./EditExpenseForm";
import { useEffect, useState } from "react";
import ExpenseWorkflow from "./ExpenseWorkflow";
import dayjs from "dayjs"

const ExpenseCreateModal = ({
    isExpenseModalOpen = false,
    setIsExpenseModalOpen = () => { },
    isCreateExpenseForm = false,
    setCreateExpenseForm = () => { },
    isEditExpenseForm = false,
    setEditExpenseForm = () => { },
    isViewExpenseForm = false,
    setViewExpenseForm = () => { },
    txnExpenseById = {},
    updateMyTxnExpense = () => { },
    updateMyTxnExpenseDraft = () => { },
    initialValues = {},
    dropdownProjectByEmployeeId = [],
    dropdownWelfareSubTypeByCode = [],
    EmployeeWelfareDropdown = [],
    createTxnExpenseDraft = () => { },
    createTxnExpense = () => { },
    CommonTypeByCode = [],
    onSubmit = () => { },
    onCreate = () => { },
    selectedRecord = null,
    form,
    currentExpenseWorkflow = [],
    isApprove = false,
    onApprove = () => { },
    onReject = () => { },
    selectedExpenseRecord = null,
    onSubmitCreate = () => { },
    onSubmitCreateDraft = () => { },
    onAttachFileChange = () => { },
    onDeleteFile = () => { }
}) => {
    const { i18n, t } = useTranslation();
    const [welfareTypeCode, setWelfareTypeCode] = useState(undefined);
    const [activeTabKey, setActiveTabKey] = useState("1");

    useEffect(() => {
        if (isExpenseModalOpen) {
            setActiveTabKey("1");
        }
    }, [isExpenseModalOpen]);

    useEffect(() => {
        if (!isExpenseModalOpen) {
            form?.resetFields();
            setWelfareTypeCode(undefined);
            setActiveTabKey("1");
        } else if (isExpenseModalOpen && isCreateExpenseForm) {
            form?.resetFields();
            setWelfareTypeCode(undefined);
            setActiveTabKey("1");
        }
    }, [isExpenseModalOpen, isCreateExpenseForm, form, activeTabKey]);

    const mapApproveRecordToFormValues = (record) => {
        if (!record) return {};

        const welfareExists = EmployeeWelfareDropdown?.some(
            item => item?.value === record?.welfare?.welfareTypeId
        );

        const welfareValue = welfareExists
            ? record?.welfare?.welfareTypeId
            : (i18n.language === "en" ? record?.welfare?.welfareNameEn : record?.welfare?.welfareName);

        return {
            ...initialValues,
            ...txnExpenseById,
            startDate: record?.startDate ? dayjs(record?.startDate) : undefined,
            endDate: record?.endDate ? dayjs(record?.endDate) : undefined,
            welfareTypeId: welfareValue,
            welfareTypeCode: record?.welfare?.subcategory?.code,
            travelBy: record?.travelBy?.id,
            projectId: record?.project?.projectId ?? null,
            startLocation: record?.startLocation,
            destination: record?.destination,
            distanceKm: record?.distanceKm,
            totalExpense: record?.totalExpense,
            totalNights: record?.totalNights,
            totalMinutes: record?.totalMinutes
                ? `${Math.floor(record.totalMinutes / 60).toString().padStart(2, '0')}:${(record.totalMinutes % 60).toString().padStart(2, '0')}`
                : undefined,
            userRights: record?.userRights,
            description: record?.description,
        };
    };

    const formInitialValues = isViewExpenseForm && txnExpenseById
        ? mapApproveRecordToFormValues(txnExpenseById)
        : initialValues;

    const handleCancel = () => {
        setIsExpenseModalOpen(false);
    };

    const tabItems = [
        {
            key: "1",
            label: t("employee.label.description"),
            children: (
                <EditExpenseForm
                    setIsExpenseModalOpen={setIsExpenseModalOpen}
                    isViewExpenseForm={isViewExpenseForm}
                    initialValues={formInitialValues}
                    updateMyTxnExpense={(values) =>
                        updateMyTxnExpense(values, selectedRecord)}
                    updateMyTxnExpenseDraft={(values) =>
                        updateMyTxnExpenseDraft(values, selectedRecord)}
                    dropdownProjectByEmployeeId={dropdownProjectByEmployeeId}
                    EmployeeWelfareDropdown={EmployeeWelfareDropdown}
                    CommonTypeByCode={CommonTypeByCode}
                    form={form}
                    isApprove={isApprove}
                    onApprove={onApprove}
                    onReject={onReject}
                    selectedExpenseRecord={selectedExpenseRecord}
                    handleCancel={handleCancel}
                    onAttachFileChange={onAttachFileChange}
                    onDeleteFile={onDeleteFile}
                />
            ),
        },
        ...(txnExpenseById?.approveStatusEn !== 'Draft' ? [{
            key: "2",
            label: t("workflow.header"),
            children: (
                <ExpenseWorkflow
                    currentExpenseWorkflow={currentExpenseWorkflow}
                    setIsExpenseModalOpen={setIsExpenseModalOpen}
                />
            )
        }] : [])
    ];

    return (
        <Modal
            key={isExpenseModalOpen ? 'open' : 'closed'}
            title={
                <Flex vertical>
                    {t("expense.expense_request")}
                    <span
                        style={{
                            color: "#667085",
                            fontSize: "14px",
                            fontWeight: "normal",
                        }}
                    >
                        {t("expense.expense_create_desc")}
                    </span>
                </Flex>
            }

            // closable={isApprove ? true : false}
            // closeIcon={false}
            maskClosable={false}
            footer={null}
            open={isExpenseModalOpen}
            width={"40vw"}
            onCancel={handleCancel}
        >
            {isCreateExpenseForm ? (
                <CreateExpenseForm
                    form={form}
                    setIsExpenseModalOpen={setIsExpenseModalOpen}
                    dropdownProjectByEmployeeId={dropdownProjectByEmployeeId}
                    // dropdownWelfareSubTypeByCode={dropdownWelfareSubTypeByCode}
                    // onSubmit={onsubmit}
                    createTxnExpense={onSubmitCreate}
                    createTxnExpenseDraft={onSubmitCreateDraft}
                    EmployeeWelfareDropdown={EmployeeWelfareDropdown}
                    CommonTypeByCode={CommonTypeByCode}
                    isCreateExpenseForm={isCreateExpenseForm}
                    isExpenseModalOpen={isExpenseModalOpen}
                    welfareTypeCode={welfareTypeCode}
                    setWelfareTypeCode={setWelfareTypeCode}
                    onAttachFileChange={onAttachFileChange}
                    onDeleteFile={onDeleteFile}
                />
            ) : isEditExpenseForm || isViewExpenseForm ? (
                <ConfigProvider theme={{
                    components: {
                        Tabs: {
                            itemHoverColor: "var(--tab-color)",
                            itemActiveColor: "var(--tab-color)"
                        },
                    },
                }}>
                    <Tabs defaultActiveKey={activeTabKey} onChange={setActiveTabKey} items={tabItems} />
                </ConfigProvider>
            ) : null}
        </Modal>
    );
};

export default ExpenseCreateModal;
